import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-lightgray py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-6 sm:px-12">
        <Reveal>
          <div className="text-center">
            <span className="text-brick font-bold text-sm tracking-[0.18em] uppercase">FAQ</span>
            <h2 className="mt-3 font-heading font-extrabold tracking-tight text-charcoal text-4xl sm:text-5xl lg:text-6xl">
              Common questions.
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`rounded-2xl border transition-colors duration-300 ${isOpen ? "bg-white border-brick/20 shadow-[0_8px_30px_rgb(0,0,0,0.05)]" : "bg-white border-black/5"}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  >
                    <span className="font-heading font-bold text-charcoal text-lg">{f.q}</span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.25 }} className="shrink-0">
                      <Plus className={`w-5 h-5 ${isOpen ? "text-brick" : "text-charcoal/50"}`} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 text-charcoal/65 text-base leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
